import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import './ProductPage.css';

const ProductPage = () => {
  const { t } = useTranslation();

  // 앱 데이터 가져오기
  const apps = t('apps', { returnObjects: true });

  return (
    <div className="product-page">
      <Helmet>
        <title>{t('meta.product.title')}</title>
        <meta name="description" content={t('meta.product.description')} />
        <meta property="og:title" content={t('meta.product.title')} />
        <meta property="og:description" content={t('meta.product.description')} />
      </Helmet>

      <h1>{t('message.product.title')}</h1>
      {/* 앱 목록 표시 */}
      {apps.map((app) => (
        <div key={app.package} className="app-item">
          <img
            src={`/icons/${app.icon}`}
            alt="App Icon"
            className="app-icon"
          />
          <div className="app-info">
            <h3>{app.title}</h3>
            <p>{app.detail}</p>
            <a
              href={`https://play.google.com/store/apps/details?id=${app.package}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('message.product.goToGooglePlay')}
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductPage;
